import { array, func, object } from 'prop-types';
import useSavingMenu from '../hooks/useSavingMenu';
import MenuModal from './MenuModal';
import GroupRoleList from './GroupRoleList';
import { ArrowBottom, ArrowRight } from 'components/icons';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import sty from '../styles/AppList.module.css';
import useModal from '../hooks/useModal';
import LoadingBackdrop from 'components/LoadingBackdrop';

/**
 * @component AppList
 * @param { Object } props
 * @param { object } props.menu
 * @param { array } props.menus
 * @param { array } props.roles
 * @param { array } props.tabs
 * @param { function } props.onMenu
 * @param { function } props.onUpdateMenu
 * @returns { JSX.Element }
 */
function AppList(props) {
	const { savingState, savingHandler } = useSavingMenu(props.onUpdateMenu);

	const state = useModal(savingState, savingHandler);

	return (
		<>
			<section className={sty.section}>
				<IconButton onClick={state.onToggle}>
					{state.open ? <ArrowBottom /> : <ArrowRight />}
				</IconButton>
				<InputBase className={sty.label} value={props.menu.appName} />
			</section>
			{props.menu.groups.map((group, index) => (
				<GroupRoleList
					key={index}
					open={state.open}
					savingState={savingState}
					savingHandler={savingHandler}
					group={group}
					roles={props.roles}
					tabs={props.tabs}
					onMenu={props.onMenu}
				/>
			))}
			<Divider />
			{state.modal && (
				<MenuModal open={state.modal} onClose={state.onClose} onSave={state.onSave} />
			)}
			<LoadingBackdrop open={savingState.loading} />
		</>
	);
}

AppList.propTypes = {
	menu: object,
	menus: array,
	roles: array,
	tabs: array,
	onMenu: func,
	onUpdateMenu: func,
};

export default AppList;
